module.exports = __webpack_public_path__ + "static/media/shanghai.ffd1b007.png";